
import ReviewOptionFieldType from '@/enums/ReviewOptionFieldType';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.components.OptionField',
  name: 'OptionField',
  props: {
    id: { type: String, required: true },
    optionType: { type: Object, required: true },
    option: { type: Object, required: true }
  },
  created() {
    this.ReviewOptionFieldType = ReviewOptionFieldType;
  }
};
